import cookieService from "../services/cookie.service";

const useHasAdminAuth = () => {
  const accessToken = cookieService.getCookie(process.env.REACT_APP_ADMIN_ACCESS_TOKEN);
  return !!accessToken;
};

export default useHasAdminAuth;
